import { Tooltip } from "@mui/material";
import { CompanyData } from "./DummyWeightInputTab/types";
import { formatWeight, toWeightPct } from "./utils";
import ScoreCell from "./ScoreCell/ScoreCell";
import WeightCell from "./WeightCell";
import PtfDeltaCell from "./PtfDeltaCell";

export const BASE_COLUMNS = [
    {
        id: 1,
        title: "COMPANY",
        sortable: true,
        value: "company_name",
        cell: (row: CompanyData) => (
            <Tooltip
                title={row.investment_thesis || ""}
                placement="top"
                arrow
                disableHoverListener={!row.investment_thesis}
            >
                <span>{row.company_name}</span>
            </Tooltip>
        ),
        show: true,
        fullDataRow: true,
    },
    {
        id: 2,
        title: "BQ",
        sortable: true,
        value: "bq",
        cell: (value: number | null) => <ScoreCell score={value} />,
        show: true,
        fullDataRow: false,
    },
    {
        id: 3,
        title: "MQ",
        sortable: true,
        value: "mq",
        cell: (value: number | null) => <ScoreCell score={value} />,
        show: true,
        fullDataRow: false,
    },
    {
        id: 4,
        title: "FV UPSIDE",
        sortable: true,
        value: "fv_upside_pct",
        cell: (value: number | null) =>
            value !== null ? `${toWeightPct(value).toFixed(1)}%` : "",
        show: true,
        fullDataRow: false,
    },
    {
        id: 5,
        title: "PTF WGT.",
        sortable: true,
        value: "portfolio_weight",
        cell: (rowOrValue: CompanyData | number | null) =>
            typeof rowOrValue === "number" || rowOrValue === null ? (
                formatWeight(rowOrValue)
            ) : (
                <WeightCell
                    weight={rowOrValue.portfolio_weight}
                    portfolioWeight={rowOrValue.portfolio_weight}
                    companyId={rowOrValue.company_id}
                    companyName={rowOrValue.company_name}
                    bbgTicker={rowOrValue.bbg_ticker || undefined}
                    showHistory={true}
                />
            ),
        show: true,
        fullDataRow: true,
    },
    {
        id: 6,
        title: "MAX POS.",
        sortable: true,
        value: "weight_max",
        cell: (value: number) => formatWeight(value),
        show: true,
        fullDataRow: false,
    },
    {
        id: 7,
        title: "TM WGT.",
        sortable: true,
        value: "team_weight",
        cell: (rowOrValue: CompanyData | number) =>
            typeof rowOrValue === "number" ? (
                formatWeight(rowOrValue)
            ) : (
                <WeightCell
                    weight={rowOrValue.team_weight}
                    portfolioWeight={rowOrValue.portfolio_weight}
                    companyId={rowOrValue.company_id}
                    companyName={rowOrValue.company_name}
                    bbgTicker={rowOrValue.bbg_ticker || undefined}
                    showHistory={true}
                />
            ),
        show: true,
        fullDataRow: true,
    },
    {
        id: 8,
        title: "PTF DELTA",
        sortable: true,
        value: "ptf_delta",
        cell: (rowOrValue: CompanyData | number) => (
            <PtfDeltaCell rowOrValue={rowOrValue} />
        ),
        show: true,
        fullDataRow: true,
    },
];
